import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const chefStoryBlockDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.chefStory,
  componentType: LAYOUT_COMPONENT_TYPE.chefStoryBlock,
  registryBlockKey: REGISTRY_BLOCK.presentation.chefStoryBlock,
  displayOrder: 4,
  content: {
    sectionTitle: loc3('Küche & Team', 'Kitchen & team', 'Bếp & đội ngũ'),
    chefName: loc3('Chef Marco Bianchi', 'Chef Marco Bianchi', 'Bếp trưởng Marco Bianchi'),
    chefTitle: loc3('Küchenchef', 'Executive chef', 'Bếp trưởng'),
    body: loc3(
      'Mediterrane Technik trifft bayerische Zutaten — geduldig und saisonal komponiert.',
      'Mediterranean technique meets Bavarian produce — composed in patient, seasonal courses.',
      'Kỹ thuật Địa Trung Hải gặp nông sản Bavaria — từng món được dựng kiên nhẫn và theo mùa.',
    ),
  },
  media: {
    portraitImage:
      'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?auto=format&fit=crop&w=960&q=80',
  },
};

/** Notes — masthead plus illustrated notes. The third note has no photo. */
export const chefStoryNotesDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.chefStoryNotes,
  componentType: LAYOUT_COMPONENT_TYPE.chefStoryBlock,
  registryBlockKey: REGISTRY_BLOCK.presentation.chefStoryNotes,
  displayOrder: 4,
  content: {
    sectionTitle: loc3(
      'Wenige Gänge, ganze Aufmerksamkeit',
      'Few courses, full attention',
      'Ít món, trọn sự chú ý',
    ),
    chefName: loc3('Clara Voss', 'Clara Voss', 'Clara Voss'),
    chefTitle: loc3('Kulinarische Philosophie', 'Culinary philosophy', 'Triết lý ẩm thực'),
    noteLabel0: loc3('Herkunft', 'Source', 'Nguồn'),
    noteBody0: loc3(
      'Rote Bete und Sellerie holen wir bei einem Hof nördlich der Stadt, solange noch Erde an der Schale hängt.',
      'Beetroot and celeriac come from a farm north of the city, while soil still clings to the skin.',
      'Củ dền và cần tây củ lấy từ một nông trại phía bắc thành phố, khi đất còn bám vỏ.',
    ),
    noteLabel1: loc3('Feuer und Fonds', 'Fire and stock', 'Lửa và nước dùng'),
    noteBody1: loc3(
      'Die Sauce beginnt am Vortag. Schalen, Knochen und Abschnitte ziehen langsam.',
      'The sauce starts the day before. Shells, bones, and trimmings draw slowly.',
      'Nước sốt bắt đầu từ hôm trước. Vỏ, xương và phần thừa ninh chậm.',
    ),
    noteLabel2: loc3('Der Abend', 'The evening', 'Buổi tối'),
    noteBody2: loc3(
      'Der Pass bleibt leise, weil die Arbeit schon getan ist.',
      'The pass stays quiet, because the work is already done.',
      'Pass giữ im, vì việc đã xong.',
    ),
  },
  media: {
    noteImage0: '/platform/defaults/menu/restaurant/fine-dining-scallop-01.jpg',
    noteImage1: '/platform/defaults/menu/restaurant/fine-dining-duck-breast-01.jpg',
  },
};
